<template>
    <div>
         <div class="programs-bottom-forms">
            <div class="center">
                <div class="inner">
                    <h2 v-if="!formVisible">Хочешь узнать больше?</h2>
                    <p v-if="!formVisible">Напиши свой мейл и получи полный доступ к персональным программам!</p>
                    <a v-if="!formVisible" class="button" @click="showForm">
                        <span>Оставайся на пике формы</span>
                    </a>
                    <form v-if="formVisible" :class="{ visible: formVisible, success }">
                        <input type="text" v-model="username" placeholder="Ваше имя">
                        <input type="email" v-model="email" :placeholder="placeholder" :class="{ error }">

                        <button type="button" class="checkbox" :class="[ { checked }, route ]" @click="check">
                            <span/>
                            Я согласен на обработку и хранение персональных данных
                        </button>

                        <button type="button" class="send" :class="[ route, { active: success } ]" @click="send" :disabled="!formValid || fetching">
                            <template v-if="success">Отправлено</template>
                            <template v-else>Отправить</template>
                        </button>
                    </form>
                </div>
                <img :src="getImg('collage.png')" class="collage">
                <p v-collide="'fadeInLeft'">
                    <slot name="subscribe"/>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import makeRequest from '@/utils/makeRequest'
    export default {
        watch: {
            email(email) {
                if (email.length) {
                    this.error = false
                    this.placeholder = 'Ваш e-mail'
                }
            },
        },
       data() {
           return {
               formVisible: false,
               username: '',
               email: '',
               placeholder: 'Ваш e-mail',
               checked: false,
               fetching: false,
               success: false,
               error: false,
           }
        },
        computed: {
            route() {
                return this.$route.name
            },
            formValid() {
                return !!(this.username.length && this.email.includes('@') && this.email.includes('.') && this.checked)
            },
        },
        methods: {
            ...mapState({
                device: state => state.device,
            }),
            getImg(name) {
                return require(`@/assets/images/${this.$route.name}/${name}`)
            },
            check() {
                this.checked = !this.checked
            },
            async send() {
                this.fetching = true

                let res = await makeRequest({
                    url: '/api.php',
                    data: {
                        name: this.username,
                        email: this.email,
                        domain: this.route,
                    },
                })

                if (res.created_at) {
                    this.success = true
                    ga('send', 'event', 'send', this.$route.name)
                } else {
                    this.error = true
                    this.username = ''
                    this.email = ''
                    this.placeholder = res[0].message
                }

                this.fetching = false
            },
            showForm() {
                this.formVisible = true;
                ga('send', 'event', 'subscribe', this.$route.name)
            },
        }
    }
</script>